// Build URLSearchParams from a normalized filter-values object.
// Arrays -> comma-joined; empty arrays / falsy values skipped.
// `map` lets callers rename a key (e.g. enumerators -> enumerator_id for Subhadra).
export function buildParams(values = {}, { map = {}, extra = {} } = {}) {
  const params = new URLSearchParams();
  const append = (key, val) => {
    const outKey = map[key] || key;
    if (Array.isArray(val)) {
      if (val.length > 0) params.append(outKey, val.join(','));
    } else if (val !== undefined && val !== null && val !== '' && val !== 'all') {
      params.append(outKey, val);
    }
  };
  Object.entries(values).forEach(([k, v]) => append(k, v));
  Object.entries(extra).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') params.append(k, v);
  });
  return params;
}

export default buildParams;
